export enum GraphicUndersampling {
  raw = 5000000,
  fast = 1000
}
